import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import DraggableDialogPaperComponent from "../../common/components/DraggableDialogPaperComponent";
import InjectStore from "../../common/utils/InjectStore";
import ExtjsCriteriaPanel from "app/common/components/input/ExtjsCriteriaPanel";
import { FormControlLabel, RadioGroup, Radio } from "@material-ui/core";

class EmailCriteriaDialog extends React.Component {
  handleNext = () => {
    this.props.store.showMapFieldsDialog();
  };

  handleBack = () => {
    const { store } = this.props;
    if (store.currentData.id) {
      store.showParsersListDialog();
    } else {
      store.showEmailFrequencyDialog();
    }
  };

  columns = [
    {
      alias_path: "EMAIL_SUBJECT",
      name: "EMAIL SUBJECT",
      alias_name: "EMAIL_SUBJECT",
      id: "EMAIL_SUBJECT",
    },
    {
      alias_path: "EMAIL_BODY",
      name: "EMAIL BODY",
      alias_name: "EMAIL_BODY",
      id: "EMAIL_BODY",
    },
    {
      alias_path: "EMAIL_FROM",
      name: "EMAIL FROM",
      alias_name: "EMAIL_FROM",
      id: "EMAIL_FROM",
    },
    {
      alias_path: "EMAIL_TO",
      name: "EMAIL TO",
      alias_name: "EMAIL_TO",
      id: "EMAIL_TO",
    },
  ];

  render() {
    const { store } = this.props;
    if (store.currentState != "email-criteria") {
      return "";
    }
    // const [emailFrequency, setEmailFrequency] = useState(null);

    // const currentSheetColumns = TL.list.settings.lookup.CriteriaHelper.formatColumns(clone(viewPort.currentListColumns), {
    //   listNameStr: viewPort.currentList.name
    // });
    // console.log(currentSheetColumns);
    const currentLisId = window.appStore.containerStore.listId,
      criteriaType =
        store.currentData.templates[store.currentTemplate].criteria_type + "";

    return (
      <Dialog
        open={store.currentState == "email-criteria"}
        // onClose={handleClose}
        PaperComponent={DraggableDialogPaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Criteria
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              {/* <label variant="subtitle1">
                  Skip Fetching If
                  </label> */}
              <RadioGroup
                aria-label="position"
                name="position"
                value={criteriaType}
                onChange={(ev) =>
                  store.handleCurrentTemplateChange(
                    ev.target.value,
                    "criteria_type"
                  )
                }
                row
              >
                <FormControlLabel
                  value="2"
                  control={<Radio color="primary" />}
                  label="Fetch all"
                  labelPlacement="start"
                />
                <FormControlLabel
                  value="1"
                  control={<Radio color="primary" />}
                  label="Skip Fetching If.."
                  labelPlacement="start"
                />
                <FormControlLabel
                  value="0"
                  control={<Radio color="primary" />}
                  label="Allow Fetching If.."
                  labelPlacement="start"
                />
              </RadioGroup>
              {criteriaType != "2" && (
                <ExtjsCriteriaPanel
                  onChange={(val) =>
                    store.handleCurrentTemplateChange(val, "criteria")
                  }
                  value={
                    store.currentData.templates[store.currentTemplate].criteria
                  }
                  lookupColumns={this.columns}
                  lookupListId={currentLisId}
                />
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleBack} color="primary">
            Back
          </Button>
          <Button onClick={store.handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={this.handleNext} color="primary">
            Next
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default InjectStore(EmailCriteriaDialog);
